module.exports = __webpack_public_path__ + "static/media/mode-4.d8d04bf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-4.svg
// module id = 977
// module chunks = 2